module.exports = __webpack_public_path__ + "toGroom-we-w-b.ad996e9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-we-w-b.jpg
// module id = XVEs
// module chunks = 0